function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Hemaka");

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "0 50.76 2.45 50.76 2.45 26.5 36.94 26.5 36.94 50.76 39.38 50.76 39.38 0.36 36.94 0.36 36.94 24.26 2.45 24.26 2.45 0.36 0 0.36 0 50.76"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "54.36 50.76 90.22 50.76 90.22 48.53 56.81 48.53 56.81 26.5 86.69 26.5 86.69 24.26 56.81 24.26 56.81 2.59 89.86 2.59 89.86 0.36 54.36 0.36 54.36 50.76"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "102.24 50.76 104.62 50.76 104.62 4.61 125.71 34.85 125.86 34.85 146.95 4.61 146.95 50.76 149.4 50.76 149.4 0.36 147.1 0.36 125.86 31.03 104.54 0.36 102.24 0.36 102.24 50.76"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M236.28,1071.08l14.47-31,14.55,31ZM225.77,1088h2.52l6.91-14.69h31.18l6.84,14.69h2.66L252,1037.24h-2.31Z",
  transform: "translate(-66 -1037.24)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "220.25 50.76 222.7 50.76 222.7 37.01 236.16 23.69 257.54 50.76 260.71 50.76 237.89 22.03 259.85 0.36 256.46 0.36 222.7 34.06 222.7 0.36 220.25 0.36 220.25 50.76"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M343.2,1071.08l14.47-31,14.55,31ZM332.69,1088h2.52l6.91-14.69H373.3l6.84,14.69h2.66l-23.9-50.76h-2.31Z",
  transform: "translate(-66 -1037.24)"
});

var SvgThinHemaka = function SvgThinHemaka(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 316.8 50.76",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgThinHemaka, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thin-hemaka.b8ad6582.svg";
export { ForwardRef as ReactComponent };